export enum Profile {
    none,
    auth,
    admin,
    devel
}